import React from "react";

import type { ArticleSlideBlock as Value } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { SlideLink } from "../MultiBrowseBlock/Slides";

import styles from "./Slide.module.scss";

export const ArticleSlide = ({
    value,
    imageSizes,
}: {
    value: Value;
    imageSizes?: string;
}) => {
    if (!value.image) return null;

    const HeadingTag = value.heading_tag ?? "h3";

    return (
        <figure className={styles.slide}>
            <SlideLink link={value.link} className={styles.link}>
                <ImageChooserBlock
                    attrs={{ className: styles.imageContainer }}
                    value={value.image}
                    sizes={imageSizes}
                    imageAttrs={{ className: styles.image, alt: "" }}
                />
                <figcaption className={styles.copy}>
                    <HeadingTag className={styles.heading}>
                        {value.heading}
                    </HeadingTag>
                    {value.body && <p className={styles.body}>{value.body}</p>}
                </figcaption>
            </SlideLink>
        </figure>
    );
};
